export default __webpack_public_path__ + "static/media/Apex-logo.7b071ba0.jpeg";